import { registerArchetype } from './index.js';
import { getRuntimes } from '../combat.js';
registerArchetype({
    id: 'focus_fire',
    apply: ({ state, source }) => {
        const r = getRuntimes(state, source.side)[source.slot];
        r.statuses.push({
            id: `focus_fire_${source.slot}`,
            kind: 'buff',
            remainingTicks: Number.MAX_SAFE_INTEGER,
            params: { focusFire: 1 }
        });
    }
});
